import { Fragment } from 'react';

import PropTypes from 'prop-types';

const WaltzActivitySection = ({
  options,
  sectionTitle,
  bubbleColor,
  bubbleTextColor,
  sectionColor,
  sectionTextColor,
  defaultBubbles
}) => {
  const paddingTop = 15;

  const bubbleHeight = 46;
  const bubbleMargin = 5;
  const bubbleTextSize = 18;

  const groupTextSize = 22;
  const groupLineHeight = groupTextSize * 1.2;

  const textOffset = (bubbleHeight + (2 * bubbleMargin)) / 2;

  // Draw in the middle of the bubble
  const currentOptions = options.length < defaultBubbles
    ? Array.from({ ...options, length: defaultBubbles })
    : options;

  const heightOfSection = (bubbleHeight * currentOptions.length)
    + (bubbleMargin * (currentOptions.length - 1));

  const width = 482;
  const height = (2 * paddingTop) + heightOfSection;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{
        borderStyle: 'solid',
        borderWidth: '1px 5px 5px 1px',
        borderRadius: '1.5rem',
        width: '100%',
        height: '100%'
      }}
    >
      {/* SECTION */}
      {currentOptions.map((option, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={`${option?.text}-${index}`}>
          {/* eslint-disable-next-line react/no-array-index-key */}
          <rect key={`bubble-${option?.text}-${index}`} x="15" y={paddingTop + (index * (bubbleHeight + bubbleMargin))} width="230.541" height={bubbleHeight} rx="15.1672" fill={bubbleColor} />
          {/* eslint-disable-next-line react/no-array-index-key */}
          <text key={`text-${option?.text}-${index}`} x="36" y={paddingTop + textOffset + (index * (bubbleHeight + bubbleMargin))} fontFamily="Inter, sans-serif" fontWeight={600} fontSize={bubbleTextSize} fill={bubbleTextColor}>{option?.text}</text>
        </Fragment>
      ))}
      {/* box */}
      <rect x="263.7414" y={paddingTop} width="202.723" height={heightOfSection} rx="15.1672" fill={sectionColor} />
      {/* message */}
      <foreignObject x="263.7414" y={paddingTop} width="202.723" height={heightOfSection}>
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            textAlign: 'center',
            alignItems: 'center'
          }}
        >
          <p
            style={{
              width: '100%',
              fontFamily: 'Inter, sans-serif',
              fontSize: `${groupTextSize}px`,
              lineHeight: `${groupLineHeight}px`,
              fontWeight: '600',
              color: sectionTextColor,
              padding: '20px'
            }}
          >
            {sectionTitle}
          </p>
        </div>
      </foreignObject>
    </svg>
  );
};

WaltzActivitySection.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string
  })),
  sectionTitle: PropTypes.string,
  bubbleColor: PropTypes.string,
  bubbleTextColor: PropTypes.string,
  sectionColor: PropTypes.string,
  sectionTextColor: PropTypes.string,
  defaultBubbles: PropTypes.number
};

WaltzActivitySection.defaultProps = {
  options: null,
  sectionTitle: null,
  bubbleColor: null,
  bubbleTextColor: '#000000',
  sectionColor: null,
  sectionTextColor: '#000000',
  defaultBubbles: 2
};

export default WaltzActivitySection;
